<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h1"><span>Heirloom</span></p>
<p class="hang-indent">For weeks now certain hours of every day</p>
<p class="hang-indenta">have been wiped sterile by the visit</p>
<p class="hang-indenta">to her hospital room where semi-privately</p>
<p class="hang-indenta">she semi-lives. For weeks</p>
<p class="hang-indenta">I’ve sourly reveled in the duty</p>
<p class="hang-indenta">while loathing its victim—my philanthropy</p>
<p class="hang-indenta">about as gracious as the bestowal of a poison cup</p>
<p class="hang-indenta">on a thirsty beggar who embodies a convenient excuse</p>
<p class="hang-indenta">but with a regrettable smell.</p>
<p class="hang-indent">For days I’ve watched her reason fracturing</p>
<p class="hang-indenta">faster even than her body’s fragmentation, as each</p>
<p class="hang-indenta">cell gradually detaches itself and shudders off</p>
<p class="hang-indenta">via the Parkinson method of interentropic travel.</p>
<p class="hang-indenta">For days the medication has made her more intense</p>
<p class="hang-indenta">than usual: cantankerous, weepy, domineering, sentimental,</p>
<p class="hang-indenta">and and and repetitive, a record that <i>will</i> not break</p>
<p class="hang-indenta">but always seems about to—the scratch on her soul itself.</p>
<p class="hang-indenta">No wonder she’s abrasive. The wonder is,</p>
<p class="hang-indenta">since nothing will help her anyway,</p>
<p class="hang-indenta">that I can still be so ungenerous.</p>
<p class="hang-indent">But then this afternoon we took each other</p>
<p class="hang-indenta">by surprise at the quite unexpected intersection</p>
<p class="hang-indenta">of Insanity and Humor—La Place de la Hallucination.</p>
<p class="hang-indenta">Forget that she frequently remembers I’m her sister,</p>
<p class="hang-indenta">or her mother, or her niece, or myself—her own child</p>
<p class="hang-indenta">but four years old again. Today she had some style.</p>
<p class="hang-indenta">Or something in me finally recognized whose style it was</p>
<p class="hang-indenta">I thought I’d made my own.</p>
<p class="hang-indent">The patent-leather shoe with the round white buckle</p>
<p class="hang-indenta">had no business being up there on the night-table, even</p>
<p class="hang-indenta">if it did ring so insistently. The fly that walked the track</p>
<p class="hang-indenta">on which the room-partitioning curtain could be pulled</p>
<p class="hang-indenta">was going to get run over but he refused to listen to advice.</p>
<p class="hang-indenta">The teensy lady who perched cross-legged on the windowsill</p>
<p class="hang-indenta">while wearing the whole poinsettia plant right in her hat</p>
<p class="hang-indenta">really should have left much earlier—but people just don’t</p>
<p class="hang-indenta">realize how visitors can tire a popular patient out.</p>
<p class="hang-indenta">And whoever had sent the basket of Florida newborn babies’ heads</p>
<p class="hang-indenta">certainly had weird taste.</p>
<p class="hang-indent">And I, who should know better, who at a younger age and chemistry</p>
<p class="hang-indenta">than she have heard radio static stutter in strict rhyme,</p>
<p class="hang-indenta">flinched from a Navaho blanket that snapped its teeth at me,</p>
<p class="hang-indenta">watched beloved faces leer with helpful malice—</p>
<p class="hang-indenta">I find myself explaining to her</p>
<p class="hang-indenta">What Is Really There. Except she’s caught me</p>
<p class="hang-indenta">as suddenly as I catch her, and in astonishment</p>
<p class="hang-indenta">I shrug and say, “You seeing ’em again, huh? Well,</p>
<p class="hang-indenta">whatthehell, why not. What else is there to see?”</p>
<p class="hang-indent">—and miracle of bitter miracle, she laughs.</p>
<p class="hang-indenta">And helpless I am laughing and the semi-roommate laughs</p>
<p class="hang-indenta">and the invisible lady in the poinsettia hat</p>
<p class="hang-indenta">can be heard distinctly laughing</p>
<p class="hang-indenta">and in this space of semi-dying there is life</p>
<p class="hang-indenta">and magic and shared paranoia thicker than water</p>
<p class="hang-indenta">and more clear than blood and we are laughing</p>
<p class="hang-indenta">while the bright shoe rings</p>
<p class="hang-indenta">and the fly dares death</p>
<p class="hang-indenta">and the oranges clamor to be fed</p>
<p class="hang-indenta">and all the thousand spear-carrying extras</p>
<p class="hang-indenta">direct from Central Casting come scurrying in</p>
<p class="hang-indenta">got up in white to hustle us apart—</p>
<p class="hang-indenta">as if our waving to each other weren’t a sign</p>
<p class="hang-indenta">beyond their understanding;</p>
<p class="hang-indenta">as if the giggly last whisper, “Try to get through</p>
<p class="hang-indenta">the night any old way you can, Love. See you</p>
<p class="hang-indenta">in the morning,” weren’t a hiccuped message</p>
<p class="hang-indenta">encoded too deep in each of all our lonely cells</p>
<p class="hang-indenta">for any deciphering.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter002.vue?3b28316c